import { AccordionBlock } from "../AccordionBlock";
import { Banner } from "../Banner";
import { BannerGrid } from "../BannerGrid";
import { BlockPlacement } from "../BlockPlacement";
import { ButtonGroupAdapter } from "../ButtonGroupAdapter";
import { CallToAction } from "../CallToAction";
import { ContentFragment } from "../ContentFragment";
import { ContentSection } from "../ContentSection";
import { FeatureItem } from "../FeatureItem";
import { FlexPlacement } from "../FlexPlacement";
import { HeroImagePlacement } from "../HeroImagePlacement";
import { HorizontalListAdapter } from "../HorizontalListAdapter";
import { LinkedImage } from "../LinkedImage";
import { LinkGroup } from "../LinkGroup";
import { ListBlockPlacement } from "../ListBlockPlacement";
import {
  AdaptiveListPlacement,
  CarouselPlacement,
  DynamicListPlacement,
  MatrixPlacement,
} from "../ListPlacements";
import { MessageBlock } from "../MessageBlock/MessageBlock";
import { PlacementList } from "../PlacementList";
import { RotatingBannerPanel } from "../RotatingBannerPanel";
import { RotatingBannerPlacement } from "../RotatingBannerPlacement";
import { SystemMessage } from "../SystemMessage";
import { TextBlock } from "../TextBlock";

export const commonPlacementComponents = {
  "accordion-block": AccordionBlock,
  "adaptive-list": AdaptiveListPlacement,
  banner: Banner,
  "banner-grid": BannerGrid,
  "block-placement": BlockPlacement,
  "button-group": ButtonGroupAdapter,
  "call-to-action": CallToAction,
  carousel: CarouselPlacement,
  "content-section": ContentSection,
  "dynamic-list": DynamicListPlacement,
  "feature-item": FeatureItem,
  "flex-placement": FlexPlacement,
  fragment: ContentFragment,
  "hero-image": HeroImagePlacement,
  "horizontal-list": HorizontalListAdapter,
  "link-group": LinkGroup,
  "linked-image": LinkedImage,
  "list-block": ListBlockPlacement,
  matrix: MatrixPlacement,
  "message-block": MessageBlock,
  PlacementList,
  "rotating-banner": RotatingBannerPlacement,
  "rotating-banner-list": RotatingBannerPanel,
  "system-message": SystemMessage,
  "text-block": TextBlock,
};
